import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BannerImage from "../../../../assets/images/ChooseUsBanner.jpg"
import { DecorSvg1, DecorSvg2, DecorSvg3, DecorSvg4 } from "../../../../assets/Svg/DecorSvg"

const FeaturesSection: React.FC = () => {
  const layersRef = useRef<(HTMLDivElement | null)[]>([]);
  const requestRef = useRef<number | null>(null);
  const mouseRef = useRef({ x: 0, y: 0 });
  const smoothMouseRef = useRef({ x: 0, y: 0 });
  const sectionRef = useRef<HTMLElement>(null);

  const layerSpeeds = [0.08, 0.12, 0.06, 0.10]; // Proportionate to previous speeds

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      mouseRef.current = {
        x: e.clientX - window.innerWidth / 2,
        y: e.clientY - window.innerHeight / 2
      };
    };

    const animate = () => {
      const smoothing = 0.2;
      smoothMouseRef.current.x += (mouseRef.current.x - smoothMouseRef.current.x) * smoothing;
      smoothMouseRef.current.y += (mouseRef.current.y - smoothMouseRef.current.y) * smoothing;

      layersRef.current.forEach((layer, index) => {
        if (layer) {
          const speed = layerSpeeds[index];
          const x = smoothMouseRef.current.x * speed;
          const y = smoothMouseRef.current.y * speed;

          // Add subtle ambient floating effect
          const ambientX = Math.sin(Date.now() * 0.001 + index) * 2;
          const ambientY = Math.cos(Date.now() * 0.001 + index) * 2;

          layer.style.transform = `translate3d(${x + ambientX}px, ${y + ambientY}px, 0)`;
        }
      });

      requestRef.current = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove);
    requestRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, []);

  return (
    <>
      <section
        id="features"
        ref={sectionRef}
        className="elementor-section elementor-top-section elementor-element elementor-element-8e2ec7b elementor-section-full_width sc_layouts_hide_on_mobile hide-decor-on-smaller-screens elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
        data-id="8e2ec7b"
        data-element_type="section">
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-641fb6b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
            data-id="641fb6b"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">

              <div
                ref={(el) => { layersRef.current[0] = el; }}
                data-parallax-params='{"parallax":0,"flow":"default","crop":"none","ease":"power2","duration":1,"delay":0,"squeeze":1,"text":"block","text_separate":0,"text_wrap":0,"mouse":1,"mouse_type":"transform","mouse_tilt_amount":70,"mouse_speed":10,"mouse_handler":"window","range_start":0,"range_end":40,"scale_start":100,"scale_end":100,"rotate_start":0,"rotate_end":0,"opacity_start":1,"opacity_end":1}'
                className="elementor-element elementor-element-2ce58b9 elementor-widget__width-auto sc_parallax_mouse elementor-absolute sc_parallax_type_transform elementor-widget-tablet__width-initial sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_need_start trx_addons_parallax_blocks_inited trx_addons_parallax_blocks_on_start"
                data-id="2ce58b9"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="image.default"
                style={{
                  position: 'absolute',
                  willChange: 'transform'
                }}
              >
                <div className="elementor-widget-container">
                  <DecorSvg1
                    width="344"
                    height="396"
                    className="attachment-full size-full wp-image-17767"
                  />
                </div>
              </div>

              {/* Image 2 */}
              <div
                ref={(el) => { layersRef.current[1] = el; }}
                data-parallax-params='{"parallax":0,"flow":"default","mouse":1,"mouse_type":"transform","mouse_tilt_amount":70,"mouse_speed":17,"mouse_handler":"window"}'
                className="elementor-element elementor-element-e6e8a3c elementor-widget__width-auto sc_parallax_mouse elementor-absolute sc_parallax_type_transform elementor-widget-tablet__width-initial sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_need_start trx_addons_parallax_blocks_inited trx_addons_parallax_blocks_on_start"
                data-id="e6e8a3c"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="image.default"
                style={{
                  position: 'absolute',
                  willChange: 'transform'
                }}
              >
                <div className="elementor-widget-container">
                  <DecorSvg2
                    width="194"
                    height="217"
                    className="attachment-full size-full wp-image-17768"
                  />
                </div>
              </div>

              {/* Image 3 */}
              <div
                ref={(el) => { layersRef.current[2] = el; }}
                data-parallax-params='{"parallax":0,"flow":"default","mouse":1,"mouse_type":"transform","mouse_tilt_amount":70,"mouse_speed":6,"mouse_handler":"window"}'
                className="elementor-element elementor-element-caafe28 elementor-widget__width-auto sc_parallax_mouse elementor-absolute sc_parallax_type_transform elementor-widget-tablet__width-initial sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_need_start trx_addons_parallax_blocks_inited trx_addons_parallax_blocks_on_start"
                data-id="caafe28"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="image.default"
                style={{
                  position: 'absolute',
                  willChange: 'transform'
                }}
              >
                <div className="elementor-widget-container">
                  <DecorSvg3
                    width="368"
                    height="368"
                    className="attachment-full size-full wp-image-17779"
                  />
                </div>
              </div>

              {/* Image 4 */}
              <div
                ref={(el) => { layersRef.current[3] = el; }}
                data-parallax-params='{"parallax":0,"flow":"default","mouse":1,"mouse_type":"transform","mouse_tilt_amount":70,"mouse_speed":12,"mouse_handler":"window"}'
                className="elementor-element elementor-element-cd91d31 elementor-widget__width-auto sc_parallax_mouse elementor-absolute sc_parallax_type_transform elementor-widget-tablet__width-initial sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_need_start trx_addons_parallax_blocks_inited trx_addons_parallax_blocks_on_start"
                data-id="cd91d31"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="image.default"
                style={{
                  position: 'absolute',
                  willChange: 'transform'
                }}
              >
                <div className="elementor-widget-container">
                  <DecorSvg4
                    width="139"
                    height="140"
                    className="attachment-full size-full wp-image-17780"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-3abc0f2 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
        data-id="3abc0f2" data-element_type="section"
        data-settings='{"background_background":"classic"}'
        id="go-anchor">
        <div className="elementor-container elementor-column-gap-extended">
          <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0e8a4f7 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
            data-id="0e8a4f7" data-element_type="column">
            <div className="elementor-widget-wrap elementor-element-populated">
              <div className="elementor-element elementor-element-2b03332 sc_fly_static elementor-widget elementor-widget-trx_sc_anchor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="2b03332" data-element_type="widget"
                data-widget_type="trx_sc_anchor.default">
                <div className="elementor-widget-container">
                  <a id="sc_anchor_go-anchor" title=""
                    className="sc_anchor sc_anchor_default" data-vc-icon=""
                    data-url=""></a>
                </div>
              </div>
              <div className="elementor-element elementor-element-1810a78 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="1810a78" data-element_type="widget"
                data-widget_type="spacer.default">
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>
              <div data-animation-type="block"
                className="elementor-element elementor-element-e4079d4 animation_type_block sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="e4079d4" data-element_type="widget"
                data-settings='{"_animation":"fadeIn"}'
                data-widget_type="trx_sc_title.default">
                <div className="elementor-widget-container">
                  <div className="sc_title sc_title_default"><span
                    className="sc_item_subtitle sc_title_subtitle sc_align_center sc_item_subtitle_above sc_item_title_style_default">What
                    we do</span>
                    <h1
                      className="sc_item_title sc_title_title sc_align_center sc_item_title_style_default sc_item_title_tag">
                      <span className="sc_item_title_text">3D printing
                        online</span></h1>
                  </div>
                </div>
              </div>
              <div className="elementor-element elementor-element-217fb10 sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="217fb10" data-element_type="widget"
                data-widget_type="spacer.default">
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>
              <div className="elementor-element elementor-element-c36b89b sc_height_small sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="c36b89b" data-element_type="widget"
                data-widget_type="spacer.default">
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>
              <div data-animation-type="sequental" data-animation-stagger=""
                className="elementor-element elementor-element-5f7c7c6 animation_type_sequental sc_fly_static elementor-widget elementor-widget-trx_sc_icons animated-separate trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="5f7c7c6" data-element_type="widget" data-settings="{}"
                data-widget_type="trx_sc_icons.default"
                data-animation-settings='{"_animation":"fadeIn","_animation_delay":200}'>
                <div className="elementor-widget-container">
                  <div
                    className="sc_icons sc_icons_default sc_icons_size_medium sc_align_center">
                    <div
                      className="sc_icons_columns_wrap sc_item_columns trx_addons_columns_wrap columns_padding_bottom columns_in_single_row">
                      <div className="trx_addons_column-1_3">
                        <div className="sc_icons_item with_more animated-item"
                          data-animation-index="0">
                          <div
                            className="sc_icons_icon sc_icon_type_ icon-blueprint">
                            <span
                              className="sc_icon_type_ icon-blueprint"></span>
                          </div>
                          <div className="sc_icons_item_details">
                            <h4 className="sc_icons_item_title">
                              <span>Tell Us Your Needs</span></h4>
                            <div className="sc_icons_item_description">
                              <span>Share what you want to create—we’ll understand your requirements and goals</span></div>
                          </div>
                        </div>
                      </div>
                      <div className="trx_addons_column-1_3">
                        <div className="sc_icons_item with_more animated-item"
                          data-animation-index="1">
                          <div
                            className="sc_icons_icon sc_icon_type_ icon-3d-printer">
                            <span className="icon-3d-printer"></span>

                          </div>
                          <div className="sc_icons_item_details">
                            <h4 className="sc_icons_item_title">
                              <span>Get a Prototype</span></h4>
                            <div className="sc_icons_item_description">
                              <span>We design and print a sample so you can see and feel the product before moving forward</span></div>
                          </div>
                        </div>
                      </div>
                      <div className="trx_addons_column-1_3">
                        <div className="sc_icons_item with_more animated-item"
                          data-animation-index="2">
                          <div
                            className="sc_icons_icon sc_icon_type_ icon-3d-cube">
                            <span
                              className="sc_icon_type_ icon-3d-cube"></span>
                          </div>
                          <div className="sc_icons_item_details">
                            <h4 className="sc_icons_item_title">
                              <span>Approve & Receive</span></h4>
                            <div className="sc_icons_item_description">
                              <span>Once you’re happy, we ship your parts and continue with full production</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="elementor-element elementor-element-797a105 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="797a105" data-element_type="widget"
                data-widget_type="spacer.default">
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-452d1ba elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="452d1ba" data-element_type="section">
                <div className="elementor-container elementor-column-gap-no">
                  <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-9139bfb sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                    data-id="9139bfb" data-element_type="column">
                    <div
                      className="elementor-widget-wrap elementor-element-populated">
                      <div className="elementor-element elementor-element-b4a5d67 elementor-widget__width-auto no-title sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="b4a5d67" data-element_type="widget"
                        data-widget_type="image.default">
                        <div className="elementor-widget-container">
                          <figure className="wp-caption">
                            <img loading="lazy" decoding="async"
                              width="700" height="866"
                              src={BannerImage}
                              className="attachment-full size-full wp-image-18230"
                              alt=""
                              srcSet={BannerImage}
                              sizes="(max-width: 700px) 100vw, 700px" />
                            <figcaption
                              className="widget-image-caption wp-caption-text"
                              style={{ display: "none" }}></figcaption>
                          </figure>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-a4ad47b scheme_dark elementor-widget__width-initial elementor-absolute elementor-widget-mobile__width-initial sc_fly_static elementor-widget elementor-widget-heading trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="a4ad47b" data-element_type="widget"
                        data-settings='{"_position":"absolute"}'
                        data-widget_type="heading.default">
                        <div className="elementor-widget-container">
                          <h3
                            className="elementor-heading-title elementor-size-default">
                            We have a wide library of materials</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-animation-type="block"
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4f5985b sc_content_align_inherit sc_layouts_column_icons_position_left animation_type_block sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                    data-id="4f5985b" data-element_type="column"
                    data-settings='{"animation":"fadeIn"}'>
                    <div
                      className="elementor-widget-wrap elementor-element-populated">
                      <div className="elementor-element elementor-element-fd30d34 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="fd30d34" data-element_type="widget"
                        data-widget_type="trx_sc_title.default">
                        <div className="elementor-widget-container">
                          <div className="sc_title sc_title_default"><span
                            className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">choose
                            us</span>
                            <h1
                              className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                              <span
                                className="sc_item_title_text">Modern 3D Printing Solutions</span></h1>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-f62b1b2 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="f62b1b2" data-element_type="widget"
                        data-widget_type="spacer.default">
                        <div className="elementor-widget-container">
                          <div className="elementor-spacer">
                            <div className="elementor-spacer-inner">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-54deb5d sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="54deb5d" data-element_type="widget"
                        data-widget_type="text-editor.default">
                        <div className="elementor-widget-container">
                          We provide professional 3D printing services that help individuals and businesses bring their ideas to life. From custom product design to rapid prototyping and bulk manufacturing, we ensure speed, precision, and reliability</div>
                      </div>
                      <div className="elementor-element elementor-element-ee45b90 sc_height_small sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="ee45b90" data-element_type="widget"
                        data-widget_type="spacer.default">
                        <div className="elementor-widget-container">
                          <div className="elementor-spacer">
                            <div className="elementor-spacer-inner">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-88cf948 sc_fly_static elementor-widget elementor-widget-heading trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="88cf948" data-element_type="widget"
                        data-widget_type="heading.default">
                        <div className="elementor-widget-container">
                          <h5
                            className="elementor-heading-title elementor-size-default">
                            <span
                              style={{ fontWeight: 700, color: "#A5A6AA", marginRight: "15px" }}>01.</span>
                            Additive manufacturing</h5>
                        </div>
                        <div className="elementor-element elementor-element-54deb5d sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="54deb5d" data-element_type="widget"
                          data-widget_type="text-editor.default">
                          <div style={{ paddingTop: '10px' }} className="elementor-widget-container">
                            Leverage advanced 3D printing technology to create durable, high-quality parts at scale</div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-19e3e47 elementor-widget-divider--view-line sc_fly_static elementor-widget elementor-widget-divider trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="19e3e47" data-element_type="widget"
                        data-widget_type="divider.default">
                        <div className="elementor-widget-container">
                          <div className="elementor-divider">
                            <span
                              className="elementor-divider-separator">
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-4cc9624 sc_fly_static elementor-widget elementor-widget-heading trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="4cc9624" data-element_type="widget"
                        data-widget_type="heading.default">
                        <div className="elementor-widget-container">
                          <h5
                            className="elementor-heading-title elementor-size-default">
                            <span
                              style={{ fontWeight: 700, color: "#A5A6AA", marginRight: "15px" }}>02.</span>
                            Rapid prototyping</h5>
                        </div>
                        <div className="elementor-element elementor-element-54deb5d sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="54deb5d" data-element_type="widget"
                          data-widget_type="text-editor.default">
                          <div style={{ paddingTop: '10px' }} className="elementor-widget-container">
                            Get prototypes delivered fast so you can test, refine, and launch products with confidence</div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-60d4e04 sc_height_small sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="60d4e04" data-element_type="widget"
                        data-widget_type="spacer.default">
                        <div className="elementor-widget-container">
                          <div className="elementor-spacer">
                            <div className="elementor-spacer-inner">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-30ffd9a sc_fly_static elementor-widget elementor-widget-trx_sc_button trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                        data-id="30ffd9a"
                        data-element_type="widget"
                        data-widget_type="trx_sc_button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="sc_item_button sc_button_wrap">
                            <Link
                              to="/about-us"
                              className="sc_button sc_button_default sc_button_size_normal sc_button_icon_left"
                            >
                              <span className="sc_button_text">
                                <span className="sc_button_title">About our company</span>
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="elementor-element elementor-element-5270a28 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-id="5270a28" data-element_type="widget"
                data-widget_type="spacer.default">
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeaturesSection;
